import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import {FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput} from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import React from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    passwordField: {
        '& input:-webkit-autofill, & input:-webkit-autofill:focus': {
            transition: "background-color 600000s 0s, color 600000s 0s"
        }
    }
}));

const PasswordField = ({name, error = false, margin = "dense", label = "Password", fullWidth = false, className, ...props}) => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValues({...values, showPassword: !values.showPassword});
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <FormControl error={error} className={clsx({[classes.textField]: !fullWidth}, className)} variant="outlined" margin={margin} fullWidth={fullWidth}>
            <InputLabel htmlFor={props.id}>{label}</InputLabel>
            <OutlinedInput
                id={props.id}
                name={name}
                error={error}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {values.showPassword ? <Visibility/> : <VisibilityOff/>}
                        </IconButton>
                    </InputAdornment>
                }
                label={label}
                fullWidth={fullWidth}
                className={classes.passwordField}
                {...props}
                type={values.showPassword ? 'text' : 'password'}
            />
        </FormControl>
    );
};

export default PasswordField;
